<template>
  <div :class="['text-input text-left h-12 w-full flex items-center', { 'error-input': error }]">
    <input
      :id="id"
      class="h-11 ml-4 mr-10 border-none outline-none w-full"
      :value="modelValue"
      :type="hidePassword ? 'password' : 'text'"
      :autocomplete="autocomplete"
      :aria-labelledby="id"
      @input="$emit('update:modelValue', $event.target.value)"
    >
    <img
      class="h-6 w-6 mr-2 cursor-pointer"
      :src="hidePassword ? require('@/assets/svg/icon_24px_unSeen.svg') : require('@/assets/svg/icon_24px_seen.svg')"
      role="button"
      tabindex="0"
      :aria-label="hidePassword ? 'Hide password' : 'Show password'"
      :alt="hidePassword ? 'Hide password' : 'Show password'"
      @click="toggleHidePassword"
      @keydown.enter="toggleHidePassword"
    >
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
    props: {
        id: String,
        error: Boolean,
        modelValue: String, // This is the new prop to accept the v-model value
        autocomplete: {
            type: String,
            default: 'off' // 默认值为 'off'，可以在使用组件时自定义
        }
    },
    setup() {
        const hidePassword = ref(true);

        const toggleHidePassword = () => {
            hidePassword.value = !hidePassword.value;
        };

        return { hidePassword, toggleHidePassword };
    },
};
</script>